import { FaExchangeAlt } from 'react-icons/fa';
import { ReceivableItem, InstallmentItem } from '../types/operations';

interface Props {
    receivables: ReceivableItem[];
    onConvert: (installments: InstallmentItem[]) => void;
    disabled?: boolean;
}

const ConvertReceivablesToInstallment: React.FC<Props> = ({ receivables, onConvert, disabled }) => {
    const handleConvert = () => {
        if (!receivables.length) return;

        const toDdMmYyyy = (date: string): string => {
            if (!date) return '';
            if (/^\d{4}-\d{2}-\d{2}/.test(date)) return date.substring(0, 10).split('-').reverse().join('/');
            return date;
        };

        const installments: InstallmentItem[] = [...receivables]
            .sort((a, b) => {
                const parseDate = (d: string): number => {
                    const converted = toDdMmYyyy(d);
                    if (!converted) return Infinity;
                    const [day, month, year] = converted.split('/');
                    const time = new Date(+year, +month - 1, +day).getTime();
                    return isNaN(time) ? Infinity : time;
                };
                return parseDate(a.receivable_due_date) - parseDate(b.receivable_due_date);
            })
            .map((item, index) => ({
                number: index + 1,
                value: item.receivable_amount || 0,
                dueDate: toDdMmYyyy(item.receivable_due_date),
                format: 'VALOR',
                business_reference: 'RECEIVABLE',
                document_id: item.document_id || '',
                document_title: item.document_title || '',
                receivable_installment: item.receivable_number || '',
                debtor_name: item.debtor_name || '',
                debtor_cpf_cnpj: item.debtor_cpf_cnpj || '',
                debtor_address_street: item.address_street || '',
                debtor_address_number: item.address_number || '',
                debtor_address_complement: item.address_complement || '',
                debtor_address_district: item.address_district || '',
                debtor_address_city: item.address_city || '',
                debtor_address_state: item.address_state || '',
                debtor_address_zip_code: item.address_zip_code || '',
                debtor_address_ibge_code: item.address_ibge_code || '',
            }));

        onConvert(installments);
    };

    return (
        <button
            type="button"
            className="inline-flex items-center gap-2 px-4 py-2 bg-gray-600 text-white text-sm font-medium rounded-md hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-gray-500 dark:hover:bg-gray-600"
            onClick={handleConvert}
            disabled={disabled || !receivables.length}
            title="Converter recebíveis em parcelas"
        >
            <FaExchangeAlt className="h-4 w-4" />
            Gerar parcelas pelos recebíveis
        </button>
    );
};

export default ConvertReceivablesToInstallment;
